import { createFileRoute } from "@tanstack/react-router"

import { uomLoader } from "@/screens/WarehouseReceiving/loaders"
import { FinalizeCheckInScreen } from "@/screens/WarehouseReceiving/subfeatures/SoftReceived/components/FinalizeCheckIn/FinalizeCheckInScreen"

export const Route = createFileRoute("/app/warehouse-receiving/soft-received/$goodsReceiptId/finalize-check-in")({
  loader: uomLoader,
  staleTime: Infinity,
  component: () => <FinalizeCheckInScreen />,
})
